// extracted by mini-css-extract-plugin
module.exports = {"itemuser":"UserGroup_itemuser__2V9Ky"};